import Component from './horizontal-divider';
export default Component;
